import script from "./AttachmentPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentPicker.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentPicker.vue?vue&type=style&index=0&id=54292c37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54292c37"]])

export default __exports__